type TPaymentSuccess = 'payment-success';
type TPaymentClose = 'payment-cancel';
type TPaymentEvent = TPaymentSuccess | TPaymentClose;

interface IPaymentEvent {
  dispatch(): void;
}

export class PaymentEvent<T> implements IPaymentEvent {
  protected eventName: string;
  protected data?: T;

  public constructor(eventName: TPaymentEvent, data?: T) {
    this.eventName = eventName;
    this.data = data;
  }
  public dispatch() {
    window.dispatchEvent(
      new CustomEvent<T>(this.eventName, {
        detail: this.data,
      }),
    );
  }
}
